import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import MyAccount from "./MyAccount/MyAccount.js";
import MyProfile from "./MyProfile/MyProfile.js";
import JumboCodes from "./JumboCodes/JumboCodes.js";
import Notifications from "./Notifications.jsx";
import PaymentPage from "./Payment/PaymentPage.js";
import AccountUsers from "components/Pages/AccountUsers/AccountUsers.tsx";
import { useUser } from "contexts/userContext/userContext.js";

import "./Profile.scss";

const Profile = () => {
  const { profilePage } = useParams();

  const { authenticateAfterMvc } = useUser();

  useEffect(() => {
    authenticateAfterMvc();
  }, []);

  const pagesEnum = {
    account: <MyAccount />,
    details: <MyProfile />,
    "account-users": <AccountUsers />,
    "account-settings": <Notifications />,
    jumbocode: <JumboCodes />,
    payments: <PaymentPage />,
  };

  return <>{pagesEnum[profilePage] || pagesEnum.account}</>;
};

export default Profile;
